import React from "react";
import { Text, makeStyles, typographyStyles } from "@fluentui/react-components";
import classNames from "classnames";
import "./OutlineStyleCount.css";

import type { TOutlineGroup } from "./types";

const useStyles = makeStyles({
  default: typographyStyles.caption1,
  strong: typographyStyles.caption1Strong,
});

interface OutlineStyleCountProps extends Pick<TOutlineGroup, "total" | "changes"> {
  notInProfile?: boolean;
  style?: keyof ReturnType<typeof useStyles>;
}

export function OutlineStyleCount({
  changes,
  total,
  notInProfile,
  style = "default",
}: OutlineStyleCountProps) {
  const styles = useStyles();

  return (
    <div className="outline-style-count">
      <div className="outline-style-count-total left">
        <div className="outline-style-count-border left">
          <Text className={styles[style]}>{total}</Text>
        </div>
      </div>
      <div
        className={classNames("outline-style-count-changes right", {
          "outline-style-count-changes-not-in-profile": notInProfile,
        })}
      >
        <div className="outline-style-count-border right">
          <Text className={styles[style]}>{changes}</Text>
        </div>
      </div>
    </div>
  );
}
